import { openTgLink } from "@/helpers/openTgLink"

interface IReferralLinks {
  tg: string
  web: string
}

export function buildReferralLinks(refCode: string): IReferralLinks {
  const botName = import.meta.env.VITE_BOTNAME
  const webAppName = import.meta.env.VITE_WEBAPP_NAME

  return {
    tg: `https://t.me/${botName}/${webAppName}?startapp=ref_${refCode}`,
    web: `${window.location.origin}/?ref=${refCode}`
  }
}

export function shareReferral({
  links,
  intro
}: {
  links: IReferralLinks
  intro: string
}): void {
  const title = `${intro}`
  const text = `\n${links.tg}\n\n${links.web}`

  const shareUrl = `https://t.me/share/url?text=${encodeURIComponent(text)}&url=${encodeURIComponent(title)}`

  openTgLink(shareUrl)
}
